import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'replaceLibelle' })
export class ReplaceLibellePipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/Hommes/g, '<i class="fa fa-male" aria-hidden="true"></i>').replace(/Femmes/g, '<i class="fa fa-female" aria-hidden="true"></i>');
  }
}
